$(document).ready(function(){
  
$('.main_product_icon').click(function (e) {
   e.preventDefault();
   var copyText =  window.location.href;

   document.addEventListener('copy', function(e) {
      e.clipboardData.setData('text/plain', copyText);
      e.preventDefault();
   }, true);

     document.execCommand('copy');  
          var message = document.createElement('p');
        message.classList.add('effect');
        message.innerHTML = 'URL copied!';
        this.parentNode.insertBefore(message, this);
        setTimeout(function () {
            $(message).remove();
        }, 2500);
});
  
$('.DstInlinemenu .h5').hover(function(){
    $('.main_grandchildlink').hide();
    $(this).parents('.grid__item').find('.main_grandchildlink').show();
});


  
  });


